import { Model, attr } from 'redux-orm';
import { createAction, createRequestConst } from '../util';

export default class OnHoldRule extends Model {
  static get modelName() {
    return 'OnHoldRule';
  }

  static reducer({ type, data }, OnHoldRule) {
    switch (type) {
      case LOAD.SUCCESS:
        data?.response?.forEach((r) => {
          OnHoldRule.create(r);
        });
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      createdAt: attr(),
      description: attr(),
      href: attr(),
      id: attr(),
      insAdminUserId: attr(),
      insUser: attr(),
      insUserId: attr(),
      offset: attr(),
      onholdRule: attr(),
      updAdminUserId: attr(),
      updatedAt: attr(),
      updUser: attr(),
      updUserId: attr(),
    };
  }
}

export const LOAD = createRequestConst(OnHoldRule.modelName);

export const load = createAction(LOAD);
